/* eslint-disable no-unused-vars */
import TrackingService from '@/services/tracking.js';
import { SET_TRACKINGS } from './types';

export async function getCaptchaTracking({commit}) {
  const {data} = await TrackingService.getCaptchaTracking();
  commit(SET_TRACKINGS, data.data.trackings);
  return data.data;
}